import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Dialog from '../../../../../1stlog-ui/src/components/Dialog'
import useOrderEntry from '../../../../containers/OrderEntry/useOrderEntry'
import AddressBookShared from '../../../AddressBookShared'
import AddressBookSharedExternal from '../../../AddressBookShared/External'
import useAddressBookDialog from './useAddressBookDialog'

const Wrapper = styled.div`
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  margin: -10px;
`

const AddressBookDialog = (props) => {
  const { onApply } = props

  const { externalAddressbook, tenantId } = useOrderEntry()

  const { isOpen, close } = useAddressBookDialog()

  const apply = (address) => {
    onApply(address)
    close()
  }

  return (
    <Dialog
      width75
      isOpen={isOpen}
      onClose={close}
      title={i18n.t(
        'choose_address_from_addressbook',
        'Adresse aus Adressbuch wählen',
      )}
      closeButton={i18n.t('close', 'Schliessen')}
    >
      <Wrapper>
        {externalAddressbook ? (
          <AddressBookSharedExternal onApply={apply} customerId={tenantId} />
        ) : (
          <AddressBookShared onApply={apply} customerId={tenantId} />
        )}
      </Wrapper>
    </Dialog>
  )
}

export default AddressBookDialog

export { default as useAddressBookDialog } from './useAddressBookDialog'
